/**
 * Created by mathieudeumie on 30/04/2014.
 */

angular.module('FlexyBeautyApp.services').
    factory('Company_Resource',["$resource","$location",
        function ($resource, $location) {
            let baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
            return $resource(baseUrl+'rest/companies/:code', {}, {
                query: { method: 'GET', isArray: true },
                listCodes: { method: 'GET', isArray: true , url:baseUrl+'rest/companies/listCodes'},
                listCodesByStatus: { method: 'GET', isArray: true , url:baseUrl+'rest/companies/list-codes-by-status'},
                listCodesDeleted: { method: 'GET', isArray: true , url:baseUrl+'rest/companies/listCodesDeleted'},
                listFromCodes: { method: 'POST', isArray: false , url:baseUrl+'rest/companies/listFromCodes'},
                listDeleted: { method: 'GET', isArray: true , url:baseUrl+'rest/companies/listDeleted'},
                listRelatedData: { method: 'GET', isArray: true , url:baseUrl+'rest/companies/listRelatedData'},
                listCardDetails: { method: 'GET', isArray: true , url:baseUrl+'rest/companies/listCardDetails'},
                listOnlineSales: { method: 'POST', isArray: false , url:baseUrl+'rest/companies/listOnlineSales'},
                listBrands: { method: 'POST', isArray: false , url:baseUrl+'rest/companies/listBrands'},
                get: { method: 'GET' },
                saveSubscriptions  : { method: 'POST', url:baseUrl+'rest/companies/saveSubscriptions'},
                copyDataFromCompanySource : { method: 'POST', url:baseUrl+'rest/companies/copyDataFromCompanySource'} ,
                deleteCompanyData : { method: 'POST', url:baseUrl+'rest/companies/deleteCompanyData'} ,
                generateSessionToken : { method: 'POST', url:baseUrl+'rest/companies/generateSessionToken'} ,
                resetDataF :  { method: 'POST', url:baseUrl+'rest/companies/resetData'} ,
                getCardRegistration: { method: 'POST', url:baseUrl+'rest/companies/getCardRegistration'},
                updateCompanyType:{ method: 'POST', url:baseUrl+'rest/companies/updateCompanyType'},
                updateUserLegal:{ method: 'POST', url:baseUrl+'rest/companies/updateUserLegal'},
                updateCompanyWallet:{ method: 'POST', url:baseUrl+'rest/companies/updateCompanyWallet'},
                updateBankAccount: { method: 'POST', url:baseUrl+'rest/companies/updateBankAccount'} ,
                createMandate: { method: 'POST', url:baseUrl+'rest/companies/createMandate'} ,
                getWalletData: { method: 'POST', url:baseUrl+'rest/companies/getWalletData'},
                getWalletAmount: { method: 'POST', url:baseUrl+'rest/companies/getWalletAmount'},
                getWalletPayIns: { method: 'POST', url:baseUrl+'rest/companies/getWalletPayIns/:page'},
                disableRwg: { method: 'PUT', url:baseUrl+'rest/reserve-with-google/subscription/disable'},
                payOut: { method: 'POST', url:baseUrl+'rest/companies/payOut'},
                billingManager: { method: 'GET', url:baseUrl+'rest/companies/:companyCode/billing-manager'},
                crmInformations: { method: 'GET', url:baseUrl+'rest/crm/:companyCode'},
                notifyAdminUpdate: { method: 'GET', url:baseUrl+'rest/companies/notify-admin-update/:companyCode?isAdmin=:isAdmin'}
            });
        }
    ]);

angular.module('FlexyBeautyApp.services').factory('Company', [
        "Company_Resource", "CompanyData", "User", "Subscription", "Invoice", "CompanyCommercialAction", "GroupData",
        "$sce", "UserData", "PartnerData", "CurrencyData", "StoreAppCode", "OfferManager",
    function (Company_Resource, CompanyData, User, Subscription, Invoice, CompanyCommercialAction, GroupData, $sce,
              UserData, PartnerData, CurrencyData, StoreAppCode, OfferManager) {
        let Company = function (resource, loadInvoices) {
            this.code = null;   //id
            this.isDeleted = false;
            this.group = null;
            this._groupId = null;
            this.timeCreated = null;
            this.timeCanceled = null;
            this.isLive = false;
            this.hasVatOnBill = true;
            this.vat = null;
            this.name = null;
            this.vatNumber = null;
            this.type = null;
            this.country = null;
            this.comment = null;
            this.appMobile = null;
            this.appMobileSecureUrl = null;
            this.manager = null;
            this._acManagerId = null;
            this.acManager = null;
            this.discountCode = null;
            this.discountCodeIsUsed = null;
            this.startModel = null;
            this.startModelId = null;
            this.modelLocale= "";
            this.modelDefaultLocale = false;
            this.companyTypeId = "";
            this.users = [];
            this.subscriptions = [];
            this.isSubscriptionsChange = false;
            this.legalType = null;
            this.companyCommercialActions = [];
            this.estimateInvoices = {
                currentMonthInvoice : null,
                nextMonthInvoice : null
            };
            this.cardDetails = {
                creationDate:null,
                active: false,
                expirationDate: "",
                alias : "",
                cardProvider: "",
                validity : ""
            };
            this.companyPaymentData = null;
            this.invoices = [];
            this.companyLegal = null;
            this.onlineAmount = 0;
            this.level3ds = null;
            this.noCnxAlertTo = null;
            this.opinionHelpDesk = 10;
            this.opinionSolution = 10;
            this.externalSessionTokens = [];
            this.opinionSolution = 10;
            this.billingPartner = null;
            this._billingPartnerId = null;
            this.billingPartnerIdCustomer = null;
            this.billingPartnerSecretKey = null;
            this.billingPartnerAccountType = null;
            this.localeCode = null;
            this.currency = null;
            this._currencyId = null;
            this.brands = [];
            this.autoInvoice = false;
            this.kycStatus = null;
            this.activeOffer = null;

            if(resource !== undefined && resource !== null) {
                this.loadObject(resource, loadInvoices);
            }

            CompanyData.add(this);
        };

        Company.prototype.loadObject = function(object, loadInvoices) {
            if (object) {
                this.code = object.code;
                this.legalType = object.legalType;
                if (object.timeCreated) {
                    this.timeCreated = new Date(object.timeCreated);
                }
                if (object.timeCanceled) {
                    this.timeCanceled = new Date(object.timeCanceled);
                }
                if (object.noCnxAlertTo) {
                    this.noCnxAlertTo = new Date(object.noCnxAlertTo);
                }
                this._groupId = object.groupId;
                this._acManagerId = object.acManagerId;
                this.isDeleted = object.isDeleted;
                this.isLive = object.isLive;
                this.hasVatOnBill = object.hasVatOnBill;
                if (object.vat !== undefined) {
                    this.vat = object.vat;
                }
                this.name = object.name;
                this.vatNumber = object.vatNumber;
                this.type = object.type;
                this.country = object.country;
                this.localeCode = object.localeCode;
                this.modelDefaultLocale = object.modelDefaultLocale;
                this.modelLocale = object.modelLocale;
                this.companyTypeId = object.companyTypeId;
                this.comment = object.comment;
                this.appMobile = object.appMobile;
                if (this.appMobile) {
                    this.appMobileSecureUrl = $sce.trustAsResourceUrl(this.appMobile);
                }
                this.manager = object.manager;
                this.startModel = object.startModel;
                this.startModelId = object.startModelId;
                this.discountCode = object.discountCode;
                this.discountCodeIsUsed = object.discountCodeIsUsed;
                this.level3ds = object.level3ds;
                this.users = [];
                let user;
                if (object.users) {
                    for (let i = 0; i < object.users.length; i++) {
                        user = UserData.getById(object.users[i].id);
                        if (!user) {
                            user = new User(object.users[i]);
                        }
                        this.users.push(user);
                        user.company = this;
                    }
                }
                this.subscriptions = [];
                if (object.subscriptions) {
                    for (let i = 0; i < object.subscriptions.length; i++) {
                        this.subscriptions.push(new Subscription(object.subscriptions[i]));
                    }
                }
                this.companyCommercialActions=[];
                if (object.companyCommercialActions) {
                    for (let i = 0; i < object.companyCommercialActions.length; i++) {
                        this.companyCommercialActions.push(new CompanyCommercialAction(object.companyCommercialActions[i], this));
                    }
                }
                if (object.estimateInvoices) {
                    this.loadEstimateInvoices(object.estimateInvoices);
                }
                this.invoices = [];
                if (object.invoices && loadInvoices) {
                    for (let i = 0; i < object.invoices.length; i++) {
                        this.invoices.push(new Invoice(object.invoices[i], this));
                    }
                }
                this.onlineAmount = object.onlineAmount;
                if (object.opinionSolution !== undefined) {
                    this.opinionSolution = object.opinionSolution;
                }
                if (object.opinionHelpDesk !== undefined) {
                    this.opinionHelpDesk = object.opinionHelpDesk;
                }

                this.externalSessionTokens=[];
                if (object.externalSessionTokens) {
                    for (let i = 0; i < object.externalSessionTokens.length; i++) {
                        this.externalSessionTokens.push(object.externalSessionTokens[i]);
                    }
                }
                this.loadPaymentData(object);
                if(object.billingPartner) {
                    this._billingPartnerId = object.billingPartner.partner.id;
                    this.billingPartnerIdCustomer = object.billingPartner.partnerIdCustomer;
                    this.billingPartnerSecretKey = object.billingPartner.partnerSecurityKey;
                    this.billingPartnerAccountType = object.billingPartner.partnerAccountType;
                }
                this._currencyId = object.currencyId;
                if(object.brands) {
                    this.brands = object.brands;
                }
                if(object.autoInvoice != null) {
                    this.autoInvoice = object.autoInvoice;
                }
                this.kycStatus = object.kycStatus;
                this.activeOffer = object.activeOffer;
            }
        };

        Company.prototype.loadRelatedData = function(object) {
            if (object) {
                this.invoices = [];
                if (object.invoices) {
                    for (let i = 0; i < object.invoices.length; i++) {
                        this.invoices.push(new Invoice(object.invoices[i], this));
                    }
                }
            }
        };

        Company.prototype.loadPaymentData = function(object) {
            if (object.companyPaymentData) {
                this.companyPaymentData =  JSON.parse(JSON.stringify(object.companyPaymentData));
            } //clone
            if (object.cardDetails) {
                this.loadObjectCardDetails(object.cardDetails);
            }
            if (object.companyLegal) {
                this.companyLegal = {
                    name : object.companyLegal.name,
                    email : object.companyLegal.email,
                    companyNumber : object.companyLegal.companyNumber,
                    headquartersAddressLine1: object.companyLegal.headquartersAddressLine1,
                    headquartersPostalCode: object.companyLegal.headquartersPostalCode,
                    headquartersCity: object.companyLegal.headquartersCity,
                    headquartersCountry: object.companyLegal.headquartersCountry,
                    legalRepresentativeFirstName : object.companyLegal.legalRepresentativeFirstName,
                    legalRepresentativeLastName : object.companyLegal.legalRepresentativeLastName,
                    legalRepresentativeEmail : object.companyLegal.legalRepresentativeEmail,
                    legalRepresentativeBirthday : new Date(object.companyLegal.legalRepresentativeBirthday),
                    legalRepresentativeCountryOfResidence : object.companyLegal.legalRepresentativeCountryOfResidence,
                    legalRepresentativeNationality : object.companyLegal.legalRepresentativeNationality
                };

            }
        };

        Company.prototype.loadObjectCardDetails = function(cardDetailsObject) {
            if (this.cardDetails && cardDetailsObject) {
                if (cardDetailsObject.creationDate) {
                    this.cardDetails.creationDate = new Date(cardDetailsObject.creationDate);
                }
                this.cardDetails.active = cardDetailsObject.active;
                this.cardDetails.expirationDate = cardDetailsObject.expirationDate;
                this.cardDetails.alias = cardDetailsObject.alias;
                this.cardDetails.cardProvider = cardDetailsObject.cardProvider;
                this.cardDetails.validity = cardDetailsObject.validity;
            }
        };

        Company.prototype.loadEstimateInvoices = function(estimateInvoices) {
            if (estimateInvoices.currentMonthInvoice) {
                this.estimateInvoices.currentMonthInvoice = new Invoice(estimateInvoices.currentMonthInvoice,this);
            }
            if (estimateInvoices.nextMonthInvoice) {
                this.estimateInvoices.nextMonthInvoice = new Invoice(estimateInvoices.nextMonthInvoice,this);
            }
        };

        Company.prototype.getObjectResource = function() {
            let companyRes = new Company_Resource();

            companyRes.isDeleted = this.isDeleted;
            companyRes.timeCanceled = this.timeCanceled;
            companyRes.noCnxAlertTo = this.noCnxAlertTo;
            companyRes.code = this.code;
            companyRes.name = this.name;
            companyRes.type = this.type;
            companyRes.country = this.country;
            companyRes.comment = this.comment;
            companyRes.appMobile = this.appMobile;
            companyRes.manager = this.manager;
            companyRes.isLive = this.isLive;
            companyRes.hasVatOnBill = this.hasVatOnBill;
            companyRes.vat = this.vat;
            companyRes.vatNumber = this.vatNumber;
            companyRes.discountCode = this.discountCode;
            companyRes.discountCodeIsUsed = this.discountCodeIsUsed;
            companyRes.isSubscriptionsChange = this.isSubscriptionsChange;
            companyRes.level3ds = this.level3ds;
            companyRes.modelLocale = this.modelLocale;
            companyRes.modelDefaultLocale = this.modelDefaultLocale;
            companyRes.companyTypeId = this.companyTypeId;
            if(this.autoInvoice != null) {
                companyRes.autoInvoice = this.autoInvoice;
            }
            if (this.acManager) {
                companyRes.acManagerId = this.acManager.id;
            }
            if (this.localeCode) {
                companyRes.localeCode = this.localeCode;
            }
            if (this.currency) {
                companyRes.currencyId = this.currency.id;
            }
            if (this.startModelId != null && this.startModelId !== '') {
                companyRes.startModelId = this.startModelId;
            }
            if (this.billingPartner) {
                companyRes.billingPartner = {};
                companyRes.billingPartner.partner = this.billingPartner;
                companyRes.billingPartner.partnerIdCustomer = this.billingPartnerIdCustomer;
                companyRes.billingPartner.partnerSecurityKey = this.billingPartnerSecretKey;
                companyRes.billingPartner.partnerAccountType = this.billingPartnerAccountType;
            }

            companyRes.subscriptions = [];
            if (this.subscriptions) {
                for (let i = 0; i < this.subscriptions.length; i++) {
                    companyRes.subscriptions.push(this.subscriptions[i].getObjectResource());
                }
            }
            companyRes.companyCommercialActions = [];
            if (this.companyCommercialActions) {
                for (let i = 0; i < this.companyCommercialActions.length; i++) {
                    companyRes.companyCommercialActions.push(this.companyCommercialActions[i].getObjectResource());
                }
            }
            companyRes.kycStatus = this.kycStatus;
            companyRes.activeOffer = this.activeOffer;
            return companyRes;
        };

        Company.prototype.getSubscriptionsResource = function() {
            let companyRes = new Company_Resource();

            companyRes.code = this.code;
            companyRes.isSubscriptionsChange = this.isSubscriptionsChange;
            companyRes.subscriptions = [];
            if (this.subscriptions) {
                for (let i = 0; i < this.subscriptions.length; i++) {
                    companyRes.subscriptions.push(this.subscriptions[i].getObjectResource());
                }
            }
            return companyRes;
        };

        Company.prototype.getCompanyLegalResource = function() {
            let companySrv = new Company_Resource();
            if (this.companyLegal) {
                companySrv.companyCode = this.code;
                companySrv.vatNumber =  this.vatNumber;
                companySrv.country =  this.country;
                companySrv.name =  this.companyLegal.name;
                companySrv.email =  this.companyLegal.email;
                companySrv.companyNumber =  this.companyLegal.companyNumber;
                companySrv.headquartersAddressLine1 =  this.companyLegal.headquartersAddressLine1;
                companySrv.headquartersPostalCode =  this.companyLegal.headquartersPostalCode;
                companySrv.headquartersCity =  this.companyLegal.headquartersCity;
                companySrv.headquartersCountry =  this.companyLegal.headquartersCountry;
                companySrv.legalRepresentativeFirstName =  this.companyLegal.legalRepresentativeFirstName;
                companySrv.legalRepresentativeLastName =  this.companyLegal.legalRepresentativeLastName;
                companySrv.legalRepresentativeEmail=  this.companyLegal.legalRepresentativeEmail;
                companySrv.legalRepresentativeBirthday =  this.companyLegal.legalRepresentativeBirthday;
                companySrv.legalRepresentativeCountryOfResidence =  this.companyLegal.legalRepresentativeCountryOfResidence;
                companySrv.legalRepresentativeNationality =  this.companyLegal.legalRepresentativeNationality;
            }

            return companySrv;
        };

        Company.prototype.addSubscription = function(subscription) {
            let index = this.subscriptions.indexOf(subscription);
            if (index === -1) {
                this.subscriptions.push(subscription);
            }
        };

        Company.prototype.addCompanyCommercialAction = function(companyCommercialAction) {
            let index = this.companyCommercialActions.indexOf(companyCommercialAction);
            if (index === -1) {
                this.companyCommercialActions.push(companyCommercialAction);
            }
        };

        Company.prototype.getSubscriptionPlan = function() {
            return OfferManager.computeCompanyOfferCode(this);
        };

        Company.prototype.hasSubscriptionActive = function(code) {
            for (let i=0; i<this.subscriptions.length; i++) {
                if (this.subscriptions[i].isActive && this.subscriptions[i].storeApp && this.subscriptions[i].storeApp.code === code) {
                    return true;
                }
            }
            return false;
        };

        Company.prototype.getOldSubscriptionCode = function() {
            return OfferManager.computeCompanyOfferCode(this);
        };

        Company.prototype.getActiveSubscription = function(code) {
            for (let i=0; i<this.subscriptions.length; i++) {
                if (this.subscriptions[i].isActive && this.subscriptions[i].storeApp && this.subscriptions[i].storeApp.code === code) {
                    return this.subscriptions[i];
                }
            }
            return null;
        };

        Company.prototype.loadRef = function() {
            if (this.subscriptions) {
                for (let i = 0; i < this.subscriptions.length; i++) {
                    this.subscriptions[i].loadRef();
                }
            }
            if (this._groupId) {
                let group = GroupData.getById(this._groupId);
                if (group) {
                    group.addCompany(this);
                }
            }
            if (this._acManagerId) {
                this.acManager = UserData.getById(this._acManagerId);
            }

            if(this._billingPartnerId) {
                this.billingPartner = PartnerData.getById(this._billingPartnerId);
            }

            if(this._currencyId) {
                this.currency = CurrencyData.getById(this._currencyId);
            }
        };

        return Company;
    }
]);

angular.module('FlexyBeautyApp.services').factory('CompanySrv',[
        "$log", "ServerSrv", "Company_Resource", "CompanyData", "Company", "OfferManager","$http",
    function ($log, ServerSrv, Company_Resource, CompanyData, Company, OfferManager,$http) {
        let companySrv = {};

        companySrv.query = function(successFunction, errorFunction) {
            Company_Resource.query(
                {},
                function (data) {
                    CompanyData.clear();
                    for(let i = 0; i < data.length; i++) {
                        new Company(data[i], true);
                    }

                    if (successFunction !== undefined) {
                        successFunction();
                    }
                },
                function (data) {
                    if (errorFunction !== undefined) {
                        errorFunction(data);
                    }
                }
            );
        };

        companySrv.fastQuery = function(loadInvoices, successFunction, errorFunction) {
            companySrv.listCodes(function(codes) {
                companySrv.loadFromCodes(codes, loadInvoices, successFunction, errorFunction);
             }, errorFunction);
        };

        companySrv.fastQueryByStatus = function(status, loadInvoices, successFunction, errorFunction) {
            companySrv.listCodesByStatus(status, function(codes) {
                companySrv.loadFromCodes(codes, loadInvoices, successFunction, errorFunction);
            }, errorFunction);
        };

        companySrv.fastQueryDeleted = function(successFunction, errorFunction) {
            companySrv.listCodesDeleted(function(codes) {
                companySrv.loadFromCodes(codes, false, successFunction, errorFunction);
            }, errorFunction);
        };

        companySrv.loadFromCodes = function(codes, loadInvoices, successFunction, errorFunction) {
            if (codes) {
                let loaders = [{loading : true, codes :[]}];
                let j = 0;
                let size = 30;
                for (let i = 0; i < codes.length; i++) {
                    loaders[j].codes.push(codes[i]);
                    if (((i+1)%size === 0) && ((i+1)<codes.length)) {
                        loaders.push({loading : true, codes :[]});
                        j++;
                    }
                }
                for (let i = 0; i < loaders.length; i++) {
                    companySrv.listFromCodes(i, loaders[i].codes,
                        function(index, companyList) {
                            if (companyList && companyList.companies) {
                                for (let i = 0; i < companyList.companies.length; i++) {
                                    new Company(companyList.companies[i], loadInvoices);
                                }
                            }
                            let finish = true;
                            loaders[index].loading = false;
                            for (let k = 0; k < loaders.length && finish; k++) {
                                finish = !loaders[k].loading;
                            }
                            if (finish && successFunction !== undefined) {
                                successFunction();
                            }
                    }, errorFunction)
                }
            }
        };

        companySrv.listFromCodes = function(index, codes, successFunction, errorFunction) {
            let rs = new Company_Resource();
            rs.codes = codes;
            rs.$listFromCodes(
                {}, //params
                function (data) {
                    if (successFunction !== undefined) {
                        successFunction(index,data);
                    }
                },
                function (data) {
                    if (errorFunction !== undefined) {
                        errorFunction(data);
                    }
                }
            );
        };

        companySrv.listOnlineSales = function(successFunction, errorFunction) {
            companySrv.listCodes(function(codes) {
                companySrv.loadOnlineFromCodes(codes, successFunction, errorFunction);
            }, errorFunction);
        };

        companySrv.listBrands = function(successFunction, errorFunction) {
            companySrv.listCodes(function(codes) {
                companySrv.loadBrandsFromCodes(codes, successFunction, errorFunction);
            }, errorFunction);
        };

        companySrv.loadBrandsFromCodes = function(codes, successFunction, errorFunction) {
            if (codes) {
                let loaders = [{loading : true, codes :[]}];
                let j = 0;
                let size = 15;
                for (let i = 0; i < codes.length; i++) {
                    loaders[j].codes.push(codes[i]);
                    if (((i+1)%size === 0) && ((i+1)<codes.length)) {
                        loaders.push({loading : true, codes :[]});
                        j++;
                    }
                }
                for (let i = 0; i < loaders.length; i++) {
                    companySrv.listBrandsFromCodes(i, loaders[i].codes,
                        function(index,companyList) {
                            let company = null;
                            if (companyList && companyList.companies) {
                                for(let i = 0; i < companyList.companies.length; i++) {
                                    if (companyList.companies[i]) {
                                        company = CompanyData.getByCode(companyList.companies[i].code);
                                        if (company) {
                                            company.brands = companyList.companies[i].brands;
                                            CompanyData.addToBrandList(company);

                                        }
                                    }
                                }
                            }
                            let finish = true;
                            loaders[index].loading = false;
                            for (let k = 0; k < loaders.length && finish; k++) {
                                finish = !loaders[k].loading;
                            }
                            if (finish && successFunction !== undefined) {
                                successFunction();
                            }
                        },function(index) {
                            loaders[index].loading = false;
                            let finish = true;
                            for (let k = 0; k < loaders.length && finish; k++) {
                                finish =  !loaders[k].loading;
                            }
                            if (finish && successFunction !== undefined) {
                                successFunction();
                            }
                        })
                }
            }
        };

        companySrv.loadOnlineFromCodes = function (codes, successFunction, errorFunction) {
            if (codes) {
                let loaders = [{loading : true, codes :[]}];
                let j = 0;
                let size = 10;
                let company;
                for (let i = 0; i < codes.length; i++) {
                    company = CompanyData.getByCode(codes[i]);
                    if (company && (company.type === "customer" || company.type === "partner") &&
                        OfferManager.hasCompanyAccessToFeature(company, StoreAppCode.OPTION_WEBSITE)) {
                        loaders[j].codes.push(codes[i]);
                        if (((i+1)%size === 0) && ((i+1)<codes.length)) {
                            loaders.push({loading : true, codes :[]});
                            j++;
                        }
                    }
                }
                for (let i = 0; i < loaders.length; i++) {
                    companySrv.listOnlineFromCodes(i, loaders[i].codes,
                        function(index, companyList) {
                            let company = null;
                            if (companyList && companyList.companies) {
                                for (let i = 0; i < companyList.companies.length; i++) {
                                    if (companyList.companies[i]) {
                                        company = CompanyData.getByCode(companyList.companies[i].code);
                                        if (company) {
                                            company.onlineAmount = companyList.companies[i].onlineAmount;
                                            if (companyList.companies[i].bookingStats && companyList.companies[i].bookingStats.length === 6) {
                                                company.bookingStats = {
                                                    nbOut: companyList.companies[i].bookingStats[0],
                                                    nbIn: companyList.companies[i].bookingStats[1],
                                                    nbOnSite: companyList.companies[i].bookingStats[2],
                                                    priceOut: companyList.companies[i].bookingStats[3],
                                                    priceIn: companyList.companies[i].bookingStats[4],
                                                    priceOnSite: companyList.companies[i].bookingStats[5]
                                                };
                                            }
                                        }
                                    }
                                }
                            }
                            let finish = true;
                            loaders[index].loading = false;
                            for (let k = 0; k < loaders.length && finish; k++) {
                                finish =  !loaders[k].loading;
                            }
                            if (finish && successFunction !== undefined) {
                                successFunction();
                            }
                        },function(index) {
                            loaders[index].loading = false;
                            let finish = true;
                            for (let k = 0; k < loaders.length && finish; k++) {
                                finish =  !loaders[k].loading;
                            }
                            if (finish && successFunction !== undefined) {
                                successFunction();
                            }
                        });
                }
            }
        };

        companySrv.listBrandsFromCodes = function(index, codes, successFunction, errorFunction) {
            let rs = new Company_Resource();
            rs.codes = codes;
            rs.$listBrands(
                {}, //params
                function (data) {
                    if (successFunction !== undefined) {
                        successFunction(index,data);
                    }
                },
                function (data) {
                    if (errorFunction !== undefined) {
                        errorFunction(index,data);
                    }
                }
            );
        };

        companySrv.listOnlineFromCodes = function(index, codes, successFunction, errorFunction) {
            let rs = new Company_Resource();
            rs.codes = codes;
            rs.$listOnlineSales(
                {}, //params
                function (data) {
                    if (successFunction !== undefined) {
                        successFunction(index, data);
                    }
                },
                function (data) {
                    if (errorFunction !== undefined) {
                        errorFunction(index, data);
                    }
                }
            );
        };

        companySrv.listCodes = function(successFunction, errorFunction) {
            Company_Resource.listCodes(
                {}, //params
                function (data) {
                    if (successFunction !== undefined) {
                        successFunction(data);
                    }
                },
                function (data) {
                    if (errorFunction !== undefined) {
                        errorFunction(data);
                    }
                }
            );
        };

        companySrv.listCodesByStatus = function(status, successFunction, errorFunction) {
            Company_Resource.listCodesByStatus(
              {status: status}, //params
              function (data) {
                  if (successFunction !== undefined) {
                      successFunction(data);
                  }
              },
              function (data) {
                  if (errorFunction !== undefined) {
                      errorFunction(data);
                  }
              }
            );
        };

        companySrv.listRelatedData = function(successFunction, errorFunction) {
            Company_Resource.listRelatedData(
                {}, //params
                function (data) {
                    let company;
                    for(let i = 0; i < data.length; i++) {
                        company = CompanyData.getByCode(data[i].code);
                        if (company) {
                            company.loadRelatedData(data[i]);
                        }
                    }
                    if (successFunction !== undefined) {
                        successFunction();
                    }
                },
                function (data) {
                    if (errorFunction !== undefined) {
                        errorFunction(data);
                    }
                }
            );
        };

        companySrv.listCodesDeleted = function(successFunction, errorFunction) {
            Company_Resource.listCodesDeleted(
              {}, //params
              function (data) {
                  if (successFunction!== undefined) {
                      successFunction(data);
                  }
              },
              function (data) {
                  if (errorFunction !== undefined) {
                      errorFunction(data);
                  }
              }
            );
        };

        companySrv.listDeleted = function(successFunction, errorFunction) {
            Company_Resource.listDeleted(
                {}, //params
                function (data) {

                    for(let i = 0; i < data.length; i++) {
                        new Company(data[i]);
                    }

                    if (successFunction !== undefined) {
                        successFunction();
                    }
                },
                function (data) {
                    if (errorFunction !== undefined) {
                        errorFunction(data);
                    }
                }
            );
        };

        companySrv.listCardDetails = function(successFunction, errorFunction) {
            Company_Resource.listCardDetails(
                {}, //params
                function (data) {
                    let company;
                    for(let i = 0; i < data.length; i++) {
                        company = CompanyData.getByCode(data[i].code);
                        if (company){
                            company.loadObjectCardDetails(data[i].cardDetails);
                        }
                    }

                    if (successFunction !== undefined) {
                        successFunction();
                    }
                },
                function (data) {
                    if (errorFunction !== undefined) {
                        errorFunction(data);
                    }
                }
            );
        };

        companySrv.reload = function (company, isReload, successFunction, errorFunction) {
            ServerSrv.startSavingProcess(companySrv.reloadSync, company, isReload, successFunction, errorFunction);
        };

        companySrv.reloadSync = function(company, isReload, successFunction, errorFunction) {
            Company_Resource.get({code:company.code}, //no params
                function (data) {
                    //Save on server success :
                    // -> add an user action (send message)
                    try {
                        company.loadObject(data, isReload);
                        company.loadRef();
                        if (successFunction !== undefined) {
                            successFunction(data);
                        }
                    } finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !== undefined) {
                            errorFunction(data);
                        }
                    } finally {
                        ServerSrv.endSavingProcess(false, (data ? data.status : null), (data && data.data ? data.data.errorCode : null));
                    }
                }
            );
        };

        companySrv.notifyAdminUpdate = function (companyCode, isAdmin) {
            Company_Resource.notifyAdminUpdate({companyCode: companyCode, isAdmin: isAdmin})
        }

        companySrv.save = function (company, successFunction, errorFunction) {
            ServerSrv.startSavingProcess(companySrv.saveSync, company, successFunction, errorFunction);
        };

        companySrv.saveSync = function (company, successFunction, errorFunction) {
            let companyRes = company.getObjectResource();
            companyRes.$save({},
                function (data) {
                    try {
                        company.loadEstimateInvoices(data);
                        company.isSubscriptionsChange = false;
                        if (successFunction !== undefined) {
                            successFunction(data);
                        }
                    } finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {
                    try{
                        if (errorFunction !== undefined) {
                            errorFunction(data);
                        }
                    } finally {
                        ServerSrv.endSavingProcess(false, (data ? data.status : null), (data && data.data ? data.data.errorCode : null));
                    }
                }
            );
        };

        companySrv.saveSubscriptions = function (company, successFunction, errorFunction) {
            ServerSrv.startSavingProcess(companySrv.saveSubscriptionsSync, company, successFunction, errorFunction);
        };

        companySrv.saveSubscriptionsSync = function (company, successFunction, errorFunction) {
            //$timeout (function () {

            let companyRes = company.getSubscriptionsResource();
            companyRes.$saveSubscriptions({}, //no params
                function (data) {
                    try {
                        company.loadEstimateInvoices(data);
                        company.isSubscriptionsChange = false;
                        if (successFunction !== undefined) {
                            successFunction(data);
                        }
                    } finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !== undefined) {
                            errorFunction(data);
                        }
                    } finally {
                        ServerSrv.endSavingProcess(false, (data ? data.status : null), (data && data.data ? data.data.errorCode : null));
                    }
                }
            );
        };

        companySrv.exportCustomerFile = function (companyCode, localeCode, format) {
            return $http({
                method: "GET", url: 'rest/v2/customers-admin/export',
                headers: {'Accept-Language': localeCode},
                params: {'company-code': companyCode, 'format': format},
                responseType: 'blob'
            });
        };

        companySrv.remove = function (company, successFunction, errorFunction) {
            CompanyData.remove(company);
            ServerSrv.startSavingProcess(companySrv.removeSync, company, successFunction, errorFunction);
        };

        companySrv.removeSync = function (company, successFunction, errorFunction) {
            let companyRes = company.getObjectResource();
            companyRes.$remove({code:company.code}, //no params
                function (data) {
                    try{
                        if (successFunction !== undefined) {
                            successFunction(data);
                        }
                    } finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {
                    //error handling goes here
                    try{
                        if (errorFunction !== undefined) {
                            errorFunction(data);
                        }
                    } finally {
                        ServerSrv.endSavingProcess(false, (data ? data.status : null), (data && data.data ? data.data.errorCode : null));
                    }
                }
            );
        };

        companySrv.copyDataFromCompanySource = function (companyTarget, companySource, itemsToCopy, successFunction, errorFunction) {
            ServerSrv.startSavingProcess(companySrv.copyDataFromCompanySourceSync, companyTarget, companySource, itemsToCopy, successFunction, errorFunction);
        };

        companySrv.copyDataFromCompanySourceSync = function (companyTarget, companySource, itemsToCopy, successFunction, errorFunction) {
            let companyRes = new Company_Resource();
            companyRes.companyTargetCode = companyTarget.code;
            companyRes.companySourceCode = companySource.code;
            companyRes.itemsToCopy = itemsToCopy;
            companyRes.$copyDataFromCompanySource({}, //no params
                function (data) {
                    try{
                        if (successFunction !== undefined) {
                            successFunction(data);
                        }
                    } finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {
                    //error handling goes here
                    try{
                        if (errorFunction !== undefined) {
                            errorFunction(data);
                        }
                    } finally {
                        ServerSrv.endSavingProcess(false, (data ? data.status : null), (data && data.data ? data.data.errorCode : null));
                    }
                }
            );
        };

        companySrv.deleteCompanyData = function (company, deleteObj, successFunction, errorFunction) {
            ServerSrv.startSavingProcess(companySrv.deleteCompanyDataSync, company, deleteObj, successFunction, errorFunction);
        };

        companySrv.deleteCompanyDataSync = function (company, deleteObj, successFunction, errorFunction) {
            let companyRes = new Company_Resource();
            companyRes.companyCode = company.code;
            companyRes.deleteCustomers =deleteObj.deleteCustomers;
            companyRes.deleteBookings =deleteObj.deleteBookings;
            companyRes.deleteProducts =deleteObj.deleteProducts;
            companyRes.deleteServices =deleteObj.deleteServices;
            companyRes.deleteSessions = deleteObj.deleteSessions;
            companyRes.$deleteCompanyData({}, //no params
                function (data) {
                    company.externalSessionTokens.push({token : data.token, timeCreated : data.timeCreated});
                    //Save on server success :
                    // -> add an user action (send message)
                    try{
                        if (successFunction !== undefined) {
                            successFunction(data);
                        }
                    } finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {
                    //error handling goes here
                    try{
                        if (errorFunction !== undefined) {
                            errorFunction(data);
                        }
                    } finally {
                        ServerSrv.endSavingProcess(false, (data ? data.status : null), (data && data.data ? data.data.errorCode : null));
                    }
                }
            );
        };

        companySrv.generateSessionToken = function (company, external, successFunction, errorFunction) {
            ServerSrv.startSavingProcess(companySrv.generateSessionTokenSync, company, external, successFunction, errorFunction);
        };

        companySrv.generateSessionTokenSync = function (company, external, successFunction, errorFunction) {
            let companyRes = new Company_Resource();
            companyRes.companyCode = company.code;
            companyRes.external =external;
            companyRes.$generateSessionToken({}, //no params
                function (data) {
                    try{
                        if (successFunction !== undefined) {
                            successFunction(data);
                        }
                    } finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {
                    //error handling goes here
                    try{
                        if (errorFunction !== undefined) {
                            errorFunction(data);
                        }
                    } finally {
                        ServerSrv.endSavingProcess(false, (data ? data.status : null), (data && data.data ? data.data.errorCode : null));
                    }
                }
            );
        };

        companySrv.loadRef=  function() {
            let companies = CompanyData.indexCompanies;
            for (let i = 0; i < companies.length; i++) {
                companies[i].loadRef();
            }
        };

        companySrv.getCardRegistration = function (company, successFunction, errorFunction) {
            if (company) {
                let companySrv = company.getCompanyLegalResource();

                companySrv.$getCardRegistration({}, //params
                    function (data) {
                        if (successFunction !== undefined) {
                            successFunction(data);
                        }
                    },
                    function (data) {
                        let errorMessage = "Error";
                        if (errorFunction !== undefined) {
                            errorFunction(errorMessage);
                        }
                    });
            } else {
                if (errorFunction !== undefined) {
                    errorFunction("companyLegal null");
                }
            }
        };

        companySrv.updateCompanyType = function (company, successFunction, errorFunction) {
            if (company) {
                let companySrv = company.getObjectResource();
                companySrv.$updateCompanyType({}, //params
                    function (data) {
                        if (successFunction !== undefined) {
                            successFunction();
                        }
                    },
                    function (data) {
                        let errorMessage = "";
                        try{
                            if (data && data.data && data.data.consumerMessage) {
                                let errorObj = JSON.parse(data.data.consumerMessage);
                                if (errorObj && errorObj.errors) {
                                    errorMessage = errorObj.errors;
                                }
                            }
                        } finally {
                            if (errorFunction !== undefined) {
                                errorFunction();
                            }
                        }
                    });
            } else {
                if (errorFunction !== undefined){
                    errorFunction();
                }
            }
        };

        companySrv.updateUserLegal = function (company, successFunction, errorFunction) {
            if (company) {
                let companySrv = company.getCompanyLegalResource();
                companySrv.$updateUserLegal({}, //params
                    function (data) {
                        if (data.userId) {
                            if (!company.companyPaymentData) {
                                company.companyPaymentData = {};
                            }
                            company.companyPaymentData.userId = data.userId;
                            company.companyPaymentData.walletId = data.walletId;
                        }
                        if (successFunction !== undefined) {
                            successFunction(data);
                        }
                    },
                    function (data) {
                        let errorMessage = "";
                        try{
                            if (data && data.data && data.data.consumerMessage) {
                                let errorObj = JSON.parse(data.data.consumerMessage);
                                if (errorObj && errorObj.errors) {
                                    errorMessage = errorObj.errors;
                                }
                            }
                        } finally {
                            if (errorFunction !== undefined) {
                                errorFunction(errorMessage);
                            }
                        }
                    });
            } else {
                if (errorFunction !== undefined) {
                    errorFunction("companyLegal null");
                }
            }
        };

        companySrv.updateCompanyWallet = function (company, successFunction, errorFunction) {
            if (company) {
                let companySrv = company.getCompanyLegalResource();
                companySrv.$updateCompanyWallet({}, //params
                    function (data) {
                        if (data.userId) {
                            if (!company.companyPaymentData) {
                                company.companyPaymentData = {};
                            }
                            company.companyPaymentData.userId = data.userId;
                            company.companyPaymentData.walletId = data.walletId;
                        }
                        if (successFunction !== undefined) {
                            successFunction(data);
                        }
                    },
                    function (data) {
                        let errorMessage = "";
                        try{
                            if (data && data.data && data.data.consumerMessage) {
                                let errorObj = JSON.parse(data.data.consumerMessage);
                                if (errorObj && errorObj.errors) {
                                    errorMessage = errorObj.errors;
                                }
                            }
                        } finally {
                            if (errorFunction !== undefined) {
                                errorFunction(errorMessage);
                            }
                        }
                    });
            } else {
                if (errorFunction !== undefined) {
                    errorFunction("companyLegal null");
                }
            }
        };

        companySrv.resetDataF = function (company, resetData, successFunction, errorFunction) {
            if (company && resetData) {
                let companySrv = new Company_Resource();
                companySrv.code = company.code;
                companySrv.removeBookings = resetData.removeBookings;
                companySrv.removeSales = resetData.removeSales;
                companySrv.removeCustomers = resetData.removeCustomers;
                companySrv.$resetDataF({}, //params
                    function (data) {
                        if (successFunction !== undefined) {
                            successFunction(data);
                        }
                    },
                    function (data) {
                        let errorMessage = "Error";
                        if (errorFunction !== undefined) {
                            errorFunction(errorMessage);
                        }
                    });

            } else {
                if (errorFunction !== undefined) {
                    errorFunction("company && resetData null");
                }
            }
        };

        companySrv.createMandate = function (company, successFunction, errorFunction) {
            Company_Resource.createMandate({}, //params
                function (resultMandate) {
                    if (company && company.companyPaymentData) {
                        company.companyPaymentData.mandateId = resultMandate.mandateId;
                    }
                    if (successFunction !== undefined) {
                        successFunction(resultMandate);
                    }
                },
                function (data) {
                    if (errorFunction !== undefined) {
                        errorFunction(data);
                    }
                });
        };

        companySrv.getWalletData = function(successFunction, errorFunction) {
            let companySrv = new Company_Resource();
            companySrv.$getWalletData({}, //params
                function (wallet) {
                    if (successFunction !== undefined) {
                        successFunction(wallet);
                    }
                },
                function (data) {
                    if (errorFunction !== undefined) {
                        errorFunction(data);
                    }
                });
        };

        companySrv.getWalletAmount = function (successFunction, errorFunction) {
            let companySrv = new Company_Resource();
            companySrv.$getWalletAmount({}, //params
                function (wallet) {
                    if (successFunction !== undefined) {
                        successFunction(wallet);
                    }
                },
                function (data) {
                    if (errorFunction !== undefined) {
                        errorFunction(data);
                    }
                });
        };

        companySrv.getWalletPayIns = function (page, successFunction, errorFunction) {
            let companySrv = new Company_Resource();
            companySrv.$getWalletPayIns({page:page}, //params
                function (wallet) {
                    if (successFunction !== undefined) {
                        successFunction(wallet);
                    }
                },
                function (data) {
                    if (errorFunction !== undefined) {
                        errorFunction(data);
                    }
                });
        };

        companySrv.payOut = function (amount, successFunction, errorFunction) {
            let companySrv = new Company_Resource();
            companySrv.amount = amount;
            companySrv.$payOut({}, //params
                function (data) {
                    if (successFunction !== undefined) {
                        successFunction(data);
                    }
                },
                function (data) {
                    if (errorFunction !== undefined) {
                        errorFunction(data);
                    }
                });
        };

        companySrv.restore = function (company, successFunction, errorFunction) {
            CompanyData.restore(company);
            ServerSrv.startSavingProcess(companySrv.restoreSync, company, successFunction, errorFunction);
        };

        companySrv.restoreSync = function (company, successFunction, errorFunction) {
            let CompanyRes = company.getObjectResource();
            CompanyRes.$save({}, //no params
                function (data) {
                    try{
                        if (successFunction !== undefined) {
                            successFunction(data);
                        }
                    } finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction !== undefined) {
                            errorFunction(data);
                        }
                    } finally {
                        ServerSrv.endSavingProcess(false, (data ? data.status : null), (data && data.data ? data.data.errorCode : null));
                    }
                }
            );
        };

        companySrv.disableRwg = function (companyCode, successFunction, errorFunction) {
            let companySrv = new Company_Resource(),
                params = {};

            if(companyCode){
                params = {
                    companyCode : companyCode
                };
            }
            companySrv.companyCode = companyCode;
            companySrv.$disableRwg(params, //params
                function () {
                    if (successFunction !== undefined) {
                        successFunction(wallet);
                    }
                },
                function (data) {
                    if (errorFunction !== undefined) {
                        errorFunction(data);
                    }
                });
        };

        companySrv.getBillingManager = function (companyCode) {
            return Company_Resource.billingManager({companyCode:companyCode}).$promise;
        }

        companySrv.getCrmInformations = function (companyCode) {
            return Company_Resource.crmInformations({companyCode:companyCode}).$promise;
        }

        return companySrv;
    }
]);

angular.module('FlexyBeautyApp.services').factory('CompanyData',["$filter",
    function ($filter) {
        let  companyDataSrv = {
            indexCompanies : [],
            activeCompanies : [],
            deletedCompanies : [],//deleted items,
            blockedCompanies: [],
            canceledCompanies: [],
            decleorCompanies : [],
            caritaCompanies : []
        };

        companyDataSrv.getByCode = function (companyCode) {
            for (let i = 0; i < this.indexCompanies.length; i++) {
                if (this.indexCompanies[i].code === companyCode) {
                    return this.indexCompanies[i];
                }
            }
            return null;
        };

        companyDataSrv.getByIndex = function (index) {
            if (index >= 0 && index < this.indexCompanies.length) {
                return this.indexCompanies[index];
            }
            return null;
        };

        companyDataSrv.getIndexOf = function (company) {
            if (company) {
                return this.indexCompanies.indexOf(company);
            }
            return -1;
        };

        companyDataSrv.addToBrandList = function (company) {
            for (let i = 0; i < company.brands.length; i++) {
                if (company.brands[i] === "DECLEOR") {
                    if (this.decleorCompanies.indexOf(company) === -1) {
                        this.decleorCompanies.push(company);
                    }
                }
                if (company.brands[i] === "CARITA") {
                    if (this.caritaCompanies.indexOf(company) === -1) {
                        this.caritaCompanies.push(company);
                    }
                }
            }
        };

        companyDataSrv.add = function (company) {
            let companyArray = this.activeCompanies;
            if (company.isDeleted) {
                companyArray = this.deletedCompanies;
            } else if (company.type=="blocked") {
                companyArray = this.blockedCompanies;
            } else if (company.type=="canceled") {
                companyArray = this.canceledCompanies;
            }
            let index = this.indexCompanies.indexOf(company);
            if (index !== -1) {
                let realIndex = companyArray.indexOf(company);
                if (realIndex === -1) {
                    companyArray.push(company);
                }
            } else {
                index = this.indexCompanies.length;
                this.indexCompanies.push(company);
                companyArray.push(company);
            }

            this.addToBrandList(company);

            return index;
        };

        companyDataSrv.remove = function (company) {
            let index = this.activeCompanies.indexOf(company);
            if (index !== -1) {
                this.activeCompanies.splice(index, 1);
                this.deletedCompanies.push(company);
                company.isDeleted = true;
            }
        };

        companyDataSrv.restore = function (company) {
            let index = this.deletedCompanies.indexOf(company);
            if (index !== -1) {
                this.deletedCompanies.splice(index, 1);
                this.activeCompanies.push(company);
                company.isDeleted = false;
            }
        };

        companyDataSrv.clear = function () {
            this.indexCompanies = [];
            this.activeCompanies = [];
            this.deletedCompanies = [];
        };

        companyDataSrv.sort = function () {
            this.activeCompanies = $filter('orderBy')(this.activeCompanies, 'name', false);
            this.deletedCompanies = $filter('orderBy')(this.deletedCompanies, 'name', false);
        };

        companyDataSrv.getActiveList = function () {
            return this.activeCompanies;
        };

        companyDataSrv.getBlockedCompanies = function () {
            return this.blockedCompanies;
        }

        companyDataSrv.getCanceledCompanies = function () {
            return this.canceledCompanies;
        }

        companyDataSrv.getDeletedList = function () {
            return this.deletedCompanies;
        };

        return companyDataSrv;
    }
]);



// WEBPACK FOOTER //
// ./js/services/models/Company.js